export default "__VITE_PUBLIC_ASSET__b8d6db43__"